import { Component, OnInit } from "@angular/core";
import { AppService } from "../services/app.service";
import { HttpService } from "../services/http.service";
import { AmplifyService } from "../services/amplify.service";
import { NavController, AlertController } from "@ionic/angular";
import { Title } from "@angular/platform-browser";

declare var mapsAutocomplete;

@Component({
  selector: "app-users",
  templateUrl: "./users.page.html",
  styleUrls: ["./users.page.scss"],
})
export class UsersPage {
  flags: any;

  constructor(
    private app: AppService,
    private http: HttpService,
    public amplify: AmplifyService,
    public alertController: AlertController,
    private navCtrl: NavController,
    public title: Title
  ) {
    this.flags = {
      usersList: [],
      usersResult: [],
      groupsList: [],
      groupsResult: [],
      locationsList: [],
      searchFocus: 0,
      modalMode: null,
      modalItem: null,
      modalStep: 1,
      usersSearch: null,
      groupsSearch: null,
      currentUser: null,
      usersFlag: "0",

      editAccess: { id: null },

      editGroupIndex: null,
      editGroup: null,
      checkbox: false,

      defaultUser: {
        cid: null,
        company_id: this.app.sysData.company_id,
        epoch: null,
        practitioner_id: null,
        first_name: null,
        last_name: null,
        suite: null,
        address: null,
        city: null,
        state: null,
        country: null,
        zip: null,
        lat: null,
        lng: null,
        email: null,
        phone: null,
        status: null,
        meta: null,
      },

      defaultAccess: {
        cid: null,
        company_id: this.app.sysData.company_id,
        location_id: null,
        group_id: null,
        epoch: null,
        permissions: null,
        token: null,
      },

      userAccess: [],

      addressSearch: null,
      matches: { address: [], googleResult: [], patientsGroup: [] },
    };
  }

  ionViewDidEnter() {
    if (this.app.sysData.access == 9) {
      this.getData();
    } else {
      this.navCtrl.navigateRoot("/home");
    }
  }

  getData() {
    this.getUsers();
    this.getLocations();
    this.reset();
  }

  getUsers() {
    this.http
      .apiGet(
        "user_access/company_id/" +
          this.app.sysData.company_id +
          "?join=user_accounts,cid,cid,id:cid:first_name:last_name:email",
        {}
      )
      .then((data) => {
        console.log("user list", data);
        this.flags.usersList = data.data;
        this.flags.usersResult = data.data;
      });
  }

  getLocations() {
    this.http.apiGet("company_sites/company_id/" + this.app.sysData.company_id, {}).then((data) => {
      console.log("location list", data.data);
      this.flags.locationsList = data.data;
    });
  }

  openModal(m) {
    this.flags.modalMode = m;
  }

  closeModal() {
    this.flags.modalMode = null;
  }

  //SEARCH
  reset() {
    this.flags.editAccess = { id: null };
    this.flags.mode = null;
  }

  //NEW USER PASSWORD FUNCTIONS
  register() {
    console.log("register run");
    this.flags.newUser.error = null;
    if (this.flags.newUser.password1 == this.flags.newUser.password2) {
      console.log("passwords match");
      var params = JSON.stringify({});

      this.amplify.registerUser(this.flags.newUser.email, this.flags.newUser.password1).then(
        (res) => {
          if (res["codeDeliveryDetails"]["Destination"]) {
            //this.app.alert(JSON.stringify(res));
            console.log(res);
            this.app.alert("Confirmation Email sent to: " + res["user"]["username"]);
            //this.promptVerificationCode();
            //this.resetStep();
            this.flags.editUser = JSON.parse(JSON.stringify(this.flags.defaultUser));
            this.flags.editUser.cid = res["userSub"];
            this.flags.editUser.email = res["user"]["username"];
            //this.flags.mode = 1.1;
          }
        },
        (err) => {
          //this.app.toast('failed ' + JSON.stringify(err), 'danger');
          this.flags.newUser.error = err.message;
          console.log(err);
        }
      );
    } else {
      console.log("passwords do not match");
      this.flags.newUser.error = "Your passwords do not match";
    }
  }

  resendVerificationCode() {
    this.flags.newUser.error = null;
    this.amplify.resendConfirmationCode(this.flags.newUser.email).then(
      (res) => {
        this.app.alert("Confirmation resent");
      },
      (err) => {
        console.log(err);
        this.flags.newUser.error = err.message;
      }
    );
  }
  //END USER FUNCTIONS

  //MOD ITEMS
  newAccess() {
    this.flags.mode = 0;
    var epoch = Date.now();
    var obj = JSON.parse(JSON.stringify(this.flags.defaultAccess));
    obj.epoch = epoch;
    obj.token = epoch.toString(36);

    this.flags.editAccess = obj;
  }

  newUser() {
    this.flags.mode = 1;
    this.flags.newUser = { username: null, password1: null, password2: null };
    this.flags.editAccess = { id: null };
  }

  modItem(m, item) {
    this.flags.mode = 1.1;
    this.flags.editAccess = JSON.parse(JSON.stringify(item));
  }

  //SAVE
  saveItem(m) {
    if (m == 1) {
      //save new user
      var obj = JSON.parse(JSON.stringify(this.flags.editAccess));
      this.http.apiPost("user_accounts", { data: obj }, null).then((data) => {
        this.app.toast("Saved", "success");
        //this.getUsers();
        //this.reset();
      });
    }

    if (m == 1.1) {
      //update user
      var obj: any = {
        id: this.flags.editAccess.join_id,
        first_name: this.flags.editAccess.join_first_name,
        last_name: this.flags.editAccess.join_last_name,
      };

      //delete temp.payroll_json;

      this.http.apiPut("user_accounts/id/" + obj.id, { data: obj }, null).then((data) => {
        this.app.toast("Saved", "success");
        this.getData();
        //this.reset();
      });
    }

    if (m == 2) {
      //save new access
      this.newAccess();
      var obj = JSON.parse(JSON.stringify(this.flags.editAccess));
      console.log("save access >>> ", obj);
      this.http.apiPost("user_access", { data: obj }, null).then((data) => {
        this.app.toast("Saved", "success");
        this.getData();
      });
    }
  }

  deleteUser(m) {
    this.app.alert("coming soon");
  }

  deleteAccess() {
    this.http.apiDelete("user_access/id/" + this.flags.editAccess.id, null).then((data) => {
      this.app.toast("Access removed successfully", "success");
      this.getData();
    });
  }

  async presentAlertConfirm(m, i) {
    const alert = await this.alertController.create({
      header: "Are you sure?",
      message: "This cannot be undone",
      buttons: [
        {
          text: "Cancel",
          role: "cancel",
          cssClass: "secondary",
          handler: (blah) => {
            console.log("Confirm Cancel: blah");
          },
        },
        {
          text: "Okay",
          handler: () => {
            this.deleteAccess();
            console.log("Confirm Okay");
          },
        },
      ],
    });

    await alert.present();
  }

  ngOnInit() {
    this.title.setTitle("Manage Users");
  }
}
